import "./Slider.css";
import { TypeAnimation } from "react-type-animation";
import wallet from "../../assets/crypto-wallet.png";
import { ArrowLongRightIcon } from "@heroicons/react/24/solid";

function Slider() {
  const openInNewTab = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };
  return (
    <div className="slider">
      <div>
        <h1 className="slider-header">
          Ease-to-Use
          <br />
          Crypto Trading for All
        </h1>
        <div className="slider-text-animation">
          <p>Effortlessly Buy and Trade{" "} </p>
      
          <span>
            <TypeAnimation
              sequence={[
                " ETH",
                3000,
                " MATIC",
                3000,
                " DAI",
                3000,
                " & More Token",
                3000,
              ]}
              speed={50}
              style={{}}
              wrapper="span"
              repeat={Infinity}
            />
          </span>
        </div>
      </div>
      <div className="slider-button-div">
        <button className="slider-button" onClick={() => openInNewTab(`https://defipe.netlify.app/`)}>
          <img src={wallet} />
          Get Started <ArrowLongRightIcon className="button-icon" />
        </button>
      </div>
    </div>
  );
}

export default Slider;
